// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"8562":"css/admin-app.6794","9602":"css/app.6794"}[chunkId] + ".css";
};